import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { colors } from 'z-react-components';

import FullWidthRow from '../FullWidthRow';

export const styles = {
    headerStyle: {
        maxWidth: 1200,
        float: 'none',
        margin: '0 auto'
    },
    titleAlign: {
        textAlign: 'center',
        marginTop: 10,
        marginBottom: 10,
        color: colors.white
    },
    logoContainer: {
        maxWidth: 300,
        margin: '0 auto'
    },
    logoStyle: {
        width: '100%',
        height: '100%'
    },
    headerImage: {
        height: 'auto',
        width: '100%'
    }
};

export default class Header extends Component {
    render() {
        return (
            <FullWidthRow backgroundColor={colors.cyan500}>
                <Col sm={12} style={styles.headerStyle}>
                    <Col sm={8} smOffset={2}>
                        <div style={styles.titleAlign}>
                            <div style={styles.logoContainer}>
                                <img alt="logo" src="./_assets/images/logo.svg" style={styles.logoStyle} />
                            </div>
                            <h4>{'Tante idee per creare la tua verifica in meno tempo'}</h4>
                        </div>
                    </Col>
                    <img alt="header_info_icon" src="./_assets/images/headerinfo.png" style={styles.headerImage} />
                </Col>
            </FullWidthRow>
        );
    }
}
